import React, { useContext, useEffect} from "react";
import http from "../utils/http";
import { ConfigContext } from "../Config/ConfigContext";

const UserInit = ({ redirectRoute = "/", unAuthedRoute = "/unauthorized" }) => {
    const { config } = useContext(ConfigContext);

    useEffect(() => {
        (async () => {
            const verifyResult = await http.get(
                {},
                `${config.uri.base}/auth/validate`
            );
    
            if (verifyResult?.valid == true) {
                window.location.href = redirectRoute;
            } else {
                window.location.href = unAuthedRoute;
            }
        })();
    },[])

    return (
        <div className="verifyUserParetnContainer">
            <div className="optionalBreakpointContainer">
                <p className="verifyUserText">Verifying...</p>
            </div>
        </div>
    );
};

export default UserInit;
